__turbopack_context__.v({
  "checkbox": "_ipa_a_checkbox",
  "label": "_ipa_a_label",
  "label-disabled": "_ipa_a_label-disabled",
  "wrapper": "_ipa_a_wrapper",
});
